import {Injectable} from '@angular/core';
import {
  expiredReservation,
  getAppSectionName,
  getReservationPlansUrl,
  Reservation
} from '../../shared/models/reservation.model';
import {Tile} from '../../shared/models/tile.model';
import {CheckInFlowData, pendingCheckIns} from '../../shared/models/check-in-flow.model';
import { hasCheckIn } from "../../shared/models/check-ins.model";
import {TileFactory} from '../../shared/factories/tile.factory';

@Injectable({providedIn: 'root'})
export class TileService {

  private readonly DEFAULT_TILE_ORDER = [
    'checkin',
    'abrir',
    'welcome',
    'howto',
    'normas',
    'reco',
    'planes',
    'mapa',
    'info',
    'otros1',
    'otros2'
  ];

  setTiles(flow: CheckInFlowData, reservation: Reservation, customOrder?: string[]): Tile[] {
    let tiles: Tile[] = [];

    if (!expiredReservation(reservation) && hasCheckIn(reservation.data.apartment) && pendingCheckIns(flow) > 0) {
      tiles.push(TileFactory.createCheckInTile());
    }

    tiles.push(TileFactory.createAbrirTile());

    if (reservation.data.apartment.home.has_welcome) {
      tiles.push(TileFactory.createWelcomeTile());
    }

    if (reservation.data.apartment.home.has_how_works) {
      tiles.push(TileFactory.createHowWorksTile());
    }


    if (reservation.data.apartment.home.has_house_rules) {
      tiles.push(TileFactory.createHouseRulesTile());
    }

    if (reservation.data.apartment.home.has_recommendations) {
      tiles.push(TileFactory.createRecommendationsTile());
    }

    const urlPlansAndServices = getReservationPlansUrl(reservation);
    if (urlPlansAndServices.trim()) {
      tiles.push(TileFactory.createPlansAndServicesTile());
    }

    if (reservation.data.apartment.lat.trim() && reservation.data.apartment.long.trim()) {
      tiles.push(TileFactory.createMapTile());
    }

    if (reservation.data.apartment.home.has_pois) {
      tiles.push(TileFactory.createInfoTile());
    }

    if (reservation.data.apartment.app_sections.length > 0) {
      tiles.push(TileFactory.createAppSectionTile(0, getAppSectionName(reservation, 0)));
    }
    if (reservation.data.apartment.app_sections.length > 1) {
      tiles.push(TileFactory.createAppSectionTile(1, getAppSectionName(reservation, 1)));
    }

    const order = customOrder ?? this.DEFAULT_TILE_ORDER;
    return this.sortTiles(tiles, order);
  }

  private sortTiles(tiles: Tile[], order: string[]): Tile[] {
    const orderMap = new Map(order.map((id, index) => [id, index]));

    return [...tiles].sort((a, b) => {
      const indexA = orderMap.has(a.id) ? orderMap.get(a.id)! : Infinity;
      const indexB = orderMap.has(b.id) ? orderMap.get(b.id)! : Infinity;

      return indexA - indexB;
    });
  }
}
